import styled from "@emotion/styled";
import ChevronRight from "@mui/icons-material/ChevronRight";
import { Alert, Skeleton } from "@mui/material";

export const NewsAndUpdatesSection = styled.section(({ theme }) => ({
	marginTop: "24px",
	backgroundColor: theme.project.colors.backgroundColors.main,
	padding: "16px",
	boxSizing: "border-box"
}));

export const NewsAndUpdatesHeader = styled.h2(({ theme }) => ({
	...theme.project.typography.heading.h6,
	color: theme.project.colors.fontColors.main,
	margin: 0,
	textAlign: "left"
}));

export const HeaderDivider = styled.div(() => ({
	backgroundColor: "rgba(0, 0, 0, 0.12)",
	height: "1px",
	marginTop: "12px",
	width: "100%"
}));

export const NewsCardGrid = styled.div(({ theme }) => ({
	display: "grid",
	gap: "12px",
	gridTemplateColumns: "repeat(3, minmax(0, 1fr))",
	marginTop: "16px",
	[theme.breakpoints.down("md")]: {
		gridTemplateColumns: "1fr"
	}
}));

export const NewsCard = styled.button(({ theme }) => ({
	backgroundColor: "transparent",
	border: "1px solid rgba(0, 0, 0, 0.08)",
	borderRadius: 0,
	color: "inherit",
	display: "grid",
	font: "inherit",
	gridTemplateColumns: "96px minmax(0, 1fr) 32px",
	minHeight: "78px",
	overflow: "hidden",
	padding: 0,
	boxSizing: "border-box",
	textAlign: "left",
	cursor: "pointer",
	transition: "background-color 0.2s ease",
	"&:hover": {
		backgroundColor: "rgba(0, 0, 0, 0.02)"
	},
	"&:focus-visible": {
		outline: `3px solid ${theme.project.colors.allColors.hex.blue.cwg.cwgBlue300}`,
		outlineOffset: "2px"
	},
	[theme.breakpoints.down("sm")]: {
		gridTemplateColumns: "76px minmax(0, 1fr) 32px",
		minHeight: "86px"
	}
}));

export const NewsCardImage = styled.img(({ theme }) => ({
	backgroundColor: theme.project.colors.allColors.hex.grayscale.gray200,
	width: "96px",
	height: "100%",
	minHeight: "78px",
	objectFit: "cover",
	flexShrink: 0,
	[theme.breakpoints.down("sm")]: {
		width: "76px",
		minHeight: "86px"
	}
}));

export const NewsCardContent = styled.div({
	alignSelf: "center",
	minWidth: 0,
	padding: "12px 16px"
});

export const NewsCardTitle = styled.h3(({ theme }) => ({
	color: theme.project.colors.fontColors.main,
	fontSize: "0.875rem",
	fontWeight: 500,
	letterSpacing: "0.15px",
	lineHeight: 1.4,
	margin: "0 0 4px",
	whiteSpace: "nowrap",
	overflow: "hidden",
	textOverflow: "ellipsis"
}));

export const NewsCardSubtitle = styled.p(({ theme }) => ({
	...theme.project.typography.body.body2,
	color: theme.project.colors.fontColors.secondary,
	margin: 0,
	lineHeight: 1.4,
	whiteSpace: "nowrap",
	overflow: "hidden",
	textOverflow: "ellipsis"
}));

export const NewsCardChevron = styled(ChevronRight)(({ theme }) => ({
	alignSelf: "center",
	color: theme.project.colors.fontColors.secondary,
	fontSize: "1.125rem",
	flexShrink: 0
}));

export const LoadingCard = styled(Skeleton)({
	borderRadius: "8px",
	height: "72px",
	transform: "none"
});

export const StateMessage = styled(Alert)({
	marginTop: "16px"
});

export const NewsArchiveButton = styled.button({
	backgroundColor: "transparent",
	border: "1px solid rgba(0, 0, 0, 0.08)",
	borderRadius: 0,
	display: "flex",
	alignItems: "center",
	justifyContent: "space-between",
	height: "38px",
	width: "100%",
	padding: "0 12px 0 16px",
	boxSizing: "border-box",
	marginTop: "12px",
	cursor: "pointer",
	transition: "background-color 0.2s ease",
	"&:hover": {
		backgroundColor: "rgba(0, 0, 0, 0.02)"
	}
});

export const NewsArchiveButtonText = styled.span(({ theme }) => ({
	color: theme.project.colors.fontColors.main,
	fontSize: "0.875rem",
	fontWeight: 500,
	letterSpacing: "0.15px",
	lineHeight: 1.4,
	textAlign: "left"
}));
